import React from 'react'

interface CanvasPointerClickIconProps {
  size?: number
  className?: string
}

const RAYS = ['M7.2 2.2L8 5.1', 'M5.1 8L2.2 7.2', 'M14 4.1L12 6', 'M6 12L4.1 14']

/**
 * Aktiver Mauszeiger der Projekt-Canvas-Toolbar (Figma: `Icon / MousePointerClick`,
 * Node `4916:265111`). Monochrom über `currentColor` — die Chip-Farbe kommt aus
 * `.canvas-toolbar__button--pointer`.
 *
 * Bewusst NICHT `lucide-react`, obwohl es dort ein gleichnamiges Icon gibt: die
 * vier Klick-Strahlen sind zwar deckungsgleich, der Pfeil aber nicht. Figma
 * zeichnet ihn **eckig und gefüllt**, Lucide gerundet und ungefüllt — über die
 * Props von `<MousePointerClick />` ist das nicht erreichbar.
 *
 * Die Koordinaten stammen 1:1 aus dem Figma-SVG-Export (viewBox 20.3002,
 * Offset +1.45 auf beiden Achsen zurückgerechnet aus den `inset`-Angaben der
 * Icon-Box). Nicht per Hand nachgezeichnet.
 *
 * Jeder Strahl ist ein eigener Pfad: Sie blitzen beim Überfahren nacheinander und springen beim
 * Wechsel auf den Zeiger auf (#315, `_toolbarIconMotion.scss`) — dieselbe Zeichnung, nur in Stücken.
 */
export const CanvasPointerClickIcon: React.FC<CanvasPointerClickIconProps> = ({ size = 24, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['canvas-pointer-click-icon', className].filter(Boolean).join(' ')}
  >
    <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Der Pfeil: gefüllt UND gestrichelt umrandet — so liegt es im Figma. */}
      <path className="canvas-pointer-click-icon__arrow" d="M9 9L14 21L15.8 15.8L21 14L9 9Z" fill="currentColor" />
      {/* Die vier Klick-Strahlen. */}
      {/* Zwei Ebenen je Strahl: Die äußere springt beim Tausch auf, der Strahl selbst blitzt beim Überfahren. */}
      {RAYS.map((d, i) => (
        <g key={d} className="canvas-pointer-click-icon__ray-pop">
          <path className={`canvas-pointer-click-icon__ray canvas-pointer-click-icon__ray--${i + 1}`} d={d} />
        </g>
      ))}
    </g>
  </svg>
)
